/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SignedUrlDetails {
    getFixupPrototypeFunction() { return SignedUrlDetails.fixupPrototype; }

    static newInstance(model: Partial<SignedUrlDetails>): SignedUrlDetails {
        let obj = Object.assign(new SignedUrlDetails(), model);
        SignedUrlDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SignedUrlDetails>): SignedUrlDetails {
        if (!model) return null;
        return SignedUrlDetails.newInstance(<SignedUrlDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SignedUrlDetails) {
        if (!obj) return;

        models.SignedUrlDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SignedUrlDetails): boolean {
        Object.setPrototypeOf(obj, SignedUrlDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.file_size === undefined) {
            this.file_size = 0;
        }
        if (this.upload_part_size === undefined) {
            this.upload_part_size = 0;
        }
        if (this.pre_signed_urls) {
            for (let val of this.pre_signed_urls) {
                models.PresignedUrlDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the file to generate re signed url
     */
    file_name: string;

    /**
     * Size of the file to be uploaded
     */
    file_size: number;

    /**
     * Upload ID for the multipart upload
     */
    upload_id: string;

    /**
     * Upload part size in bytes
     */
    upload_part_size: number;

    pre_signed_urls: Array<models.PresignedUrlDetails>;

}
